@if (address && address.id) {
  <dl>
    <dt>Name</dt>
    <dd>
      {{ address.firstname ? address.firstname : ( customer ? customer.firstname : "" ) }}
      {{ address.lastname ? address.lastname : ( customer ? customer.lastname : "" ) }}
    </dd>
    @if (address.company) {
      <dt>Firma</dt>
      <dd>{{ address.company }}</dd>
    }
    <dt>Straße</dt>
    <dd>{{ address.street }}@if (address.houseNumber) {
      <span> {{address.houseNumber}}</span>
    }</dd>
    <dt>PLZ & Ort</dt>
    <dd>{{ address.postalcode }} {{ address.city }}</dd>
    <dt>Telefonnummer</dt>
    <dd>{{ address.telephone ? address.telephone : '&nbsp;' }}</dd>
    <button class="mt-3 btn btn-green btn-sm" (click)="onEdit.emit(address)">Diese Adresse bearbeiten</button>
  </dl>
}